module.exports = __webpack_public_path__ + "static/media/abel-regular-webfont.e10e6e82.woff";